import { StyleSheet } from 'aphrodite/no-important';
import { LARGE_SCREEN_SIZE } from '../../../mediaQueries.const';

export const { sectionStyle } = StyleSheet.create({
  sectionStyle: {
    maxWidth: `${LARGE_SCREEN_SIZE}px`,
    margin: '0 auto',
  },
});
